export function getAboutSections(about) {
  if (Array.isArray(about.sections)) return about.sections;

  return [
    { _key: 'team', kind: 'team', title: 'Team' },
    ...(about.curators?.length
      ? [{ _key: 'advisors', kind: 'advisors', title: 'Artform Advisors' }]
      : []),
    { _key: 'board', kind: 'board', title: 'Board' },
    {
      _key: 'referenceGroup',
      kind: 'referenceGroup',
      title: 'Local Community Reference Group'
    },
    ...(about.information || []).map((section, index) => ({
      ...section,
      _key: section._key || `information-${index}`,
      kind: 'content'
    })),
    { _key: 'annualReports', kind: 'annualReports', title: 'Annual Reports' },
    { _key: 'history', kind: 'history', title: 'History' }
  ];
}

export function getHistoryImages(about) {
  if (Array.isArray(about.historyImages)) return about.historyImages;
  return (about.buildingImages || []).map((image, index) => ({
    _key: image._key || `history-${index}`,
    image,
    caption: image.asset?.description
  }));
}
